// GEN-DO mock data — investor demo (frontend only)

export const currentUser = {
  name: "Jordan",
  initial: "J",
  role: "grow", // 'grow' (kid) | 'empower' (parent/neighbor)
  rankIndex: 1, // 0..4
  memberSince: "Jan 2025",
  xp: 650,
  xpToNext: 1000,
  earned: 247,
  tasksDone: 31,
  badges: 4,
  rating: 4.9,
  streak: 12,
  weeklyGoal: 75,
  weeklyEarned: 47,
  parent: "Sarah Miller",
};

export const ranks = [
  { level: 1, title: "ASSOCIATE", tier: "Bronze", color: "#c98a4b" },
  { level: 2, title: "MANAGER", tier: "Silver", color: "#9aa3b2" },
  { level: 3, title: "DIRECTOR", tier: "Gold", color: "#e6b325" },
  { level: 4, title: "VP", tier: "Platinum", color: "#7f8fb0" },
  { level: 5, title: "CEO", tier: "Diamond", color: "#4fc3e8" },
];

export const categories = ["All", "Outdoor", "Indoor", "Errands", "Pets"];

// icon = lucide icon name; tint = circle color
export const chores = [
  {
    id: "mow-lawn",
    title: "Mow the Lawn",
    category: "Outdoor",
    icon: "Sprout",
    tint: "#4fae3f",
    pay: 25,
    xp: 250,
    rating: 4.0,
    reviews: 24,
    duration: "2 hr",
    distance: "0.3 mi",
    urgent: true,
    poster: "neighbor-danforth",
    description:
      "Front lawn and the small side strip need a fresh cut before the weekend. Mower and gas are provided. A $5 tip is offered if the edges are trimmed too.",
    checklist: [
      "Mow front lawn (marked area)",
      "Edge along the driveway & path",
      "Bag & set clippings by the curb",
      "Return mower to the garage",
    ],
    slots: ["Sat, Jun 21 · 10 AM", "Sun, Jun 22 · 9 AM", "Sat, Jun 28 · 11 AM"],
  },
  {
    id: "walk-dog",
    title: "Walk the Dog",
    category: "Pets",
    icon: "Dog",
    tint: "#f5911e",
    pay: 15,
    xp: 250,
    rating: 5.0,
    reviews: 18,
    duration: "45 min",
    distance: "0.1 mi",
    urgent: false,
    poster: "neighbor-lopez",
    description:
      "Our golden retriever Max needs a 45-minute afternoon walk around the block. He's friendly, leash-trained, and loves the park loop.",
    checklist: ["Leash Max securely", "Walk the park loop", "Fresh water when back", "Text a photo update"],
    slots: ["Weekdays · 3 PM", "Sat, Jun 21 · 2 PM"],
  },
  {
    id: "grocery-run",
    title: "Grocery Run",
    category: "Errands",
    icon: "ShoppingCart",
    tint: "#3b57c9",
    pay: 20,
    xp: 250,
    rating: 4.0,
    reviews: 31,
    duration: "1 hr",
    distance: "0.5 mi",
    urgent: false,
    poster: "neighbor-chen",
    description:
      "Pick up a short grocery list from the corner market (10 items). List and reusable bags provided. Money handled through the app wallet.",
    checklist: ["Collect list & bags", "Shop 10 items", "Keep the receipt", "Deliver to porch"],
    slots: ["Fri, Jun 20 · 4 PM", "Sat, Jun 21 · 10 AM"],
  },
  {
    id: "car-wash",
    title: "Car Wash",
    category: "Outdoor",
    icon: "CarFront",
    tint: "#22a7c9",
    pay: 30,
    xp: 250,
    rating: 4.0,
    reviews: 12,
    duration: "1.5 hr",
    distance: "0.2 mi",
    urgent: true,
    poster: "neighbor-danforth",
    description:
      "Exterior wash + wheels for a sedan in the driveway. Bucket, soap and hose provided. Bonus for a quick interior vacuum.",
    checklist: ["Rinse & soap exterior", "Scrub wheels", "Rinse & dry", "Optional: vacuum interior"],
    slots: ["Sun, Jun 22 · 11 AM", "Sat, Jun 28 · 1 PM"],
  },
  {
    id: "helper",
    title: "Helper Services",
    category: "Indoor",
    icon: "HandHelping",
    tint: "#8b5cf6",
    pay: 40,
    xp: 250,
    rating: 4.0,
    reviews: 8,
    duration: "3 hr",
    distance: "0.4 mi",
    urgent: false,
    poster: "neighbor-lopez",
    description:
      "Help organize the garage and carry a few light boxes. Great for building teamwork and organization skills.",
    checklist: ["Sort boxes by label", "Sweep the floor", "Stack shelves neatly"],
    slots: ["Sat, Jun 21 · 12 PM"],
  },
  {
    id: "lawn-mowing-2",
    title: "Water the Plants",
    category: "Outdoor",
    icon: "Flower2",
    tint: "#4fae3f",
    pay: 18,
    xp: 250,
    rating: 4.0,
    reviews: 15,
    duration: "1 hr",
    distance: "0.6 mi",
    urgent: false,
    poster: "neighbor-chen",
    description:
      "Water the front garden beds and the back patio pots while we're away for the weekend. Simple and relaxing.",
    checklist: ["Water front beds", "Water patio pots", "Check for wilting"],
    slots: ["Sat, Jun 21 · 8 AM", "Sun, Jun 22 · 8 AM"],
  },
];

export const neighbors = {
  "neighbor-danforth": {
    name: "The Danforth Family",
    initial: "D",
    color: "#f5911e",
    rating: 5.0,
    jobsPosted: 14,
    backgroundCheck: {
      status: "verified",
      provider: "Checkr",
      clearedOn: "May 2, 2025",
      items: ["Identity verified", "National criminal search", "Sex offender registry — clear", "Address confirmed"],
    },
    reviews: [
      { name: "Jordan", stars: 5, text: "Super friendly and always fair with pay. Felt safe the whole time!" },
      { name: "Riley", stars: 5, text: "Clear instructions and a kind family. Great first job." },
    ],
  },
  "neighbor-lopez": {
    name: "Mrs. Lopez",
    initial: "L",
    color: "#3b57c9",
    rating: 4.9,
    jobsPosted: 9,
    backgroundCheck: {
      status: "verified",
      provider: "Checkr",
      clearedOn: "Apr 18, 2025",
      items: ["Identity verified", "National criminal search", "Sex offender registry — clear", "Address confirmed"],
    },
    reviews: [{ name: "Sam", stars: 5, text: "Max is the sweetest dog. Mrs. Lopez is lovely." }],
  },
  "neighbor-chen": {
    name: "The Chen Household",
    initial: "C",
    color: "#22a7c9",
    rating: 4.8,
    jobsPosted: 6,
    backgroundCheck: {
      status: "verified",
      provider: "Checkr",
      clearedOn: "Jun 1, 2025",
      items: ["Identity verified", "National criminal search", "Sex offender registry — clear", "Address confirmed"],
    },
    reviews: [{ name: "Alex", stars: 4, text: "Organized and friendly. Paid instantly." }],
  },
};

export const quickActions = [
  { label: "Find Chores", icon: "Search", to: "/explore", tint: "#3b57c9" },
  { label: "Piggy Bank", icon: "PiggyBank", to: "/earnings", tint: "#f5911e" },
  { label: "Academy", icon: "GraduationCap", to: "/academy", tint: "#8b5cf6" },
  { label: "My Calendar", icon: "CalendarDays", to: "/calendar", tint: "#4fae3f" },
];

export const badges = [
  { name: "Speed Star", icon: "Zap", tint: "#f5911e" },
  { name: "Top Rated", icon: "Star", tint: "#e6b325" },
  { name: "$100 Club", icon: "DollarSign", tint: "#4fae3f" },
  { name: "Streaks", icon: "Flame", tint: "#8b5cf6" },
];

export const calendarTasks = {
  "18": [
    { time: "9:00 AM", title: "Lawn Mowing", pay: 25, dur: "2 hr", status: "Upcoming", tint: "#4fae3f" },
    { time: "2:00 PM", title: "Dog Walking", pay: 15, dur: "45 min", status: "Upcoming", tint: "#f5911e" },
    { time: "5:30 PM", title: "Grocery Run", pay: 20, dur: "1 hr", status: "Done", tint: "#3b57c9" },
  ],
};

export const weekDays = [
  { d: "M", n: 16 }, { d: "T", n: 17 }, { d: "W", n: 18, active: true },
  { d: "T", n: 19 }, { d: "F", n: 20 }, { d: "S", n: 21 }, { d: "S", n: 22 },
];

export const notifications = [
  { id: 1, icon: "CheckCircle2", tint: "#4fae3f", title: "Task Completed", body: "Mow the Lawn — you earned $25 + 250 XP", time: "Just now", dot: "#4fae3f" },
  { id: 2, icon: "Flame", tint: "#f5911e", title: "Streak Alert", body: "12 days in a row! 2 more days for Hot Streak badge", time: "1 hr ago", dot: "#f5911e" },
  { id: 3, icon: "MapPin", tint: "#3b57c9", title: "New Chore Nearby", body: "Dog Walking · $15 · 0.1 mi away", time: "2 hrs ago", dot: "#3b57c9" },
  { id: 4, icon: "ShieldCheck", tint: "#22a7c9", title: "Parent Approved a Job", body: "Sarah approved 'Grocery Run'. You're cleared to start!", time: "3 hrs ago" },
  { id: 5, icon: "Star", tint: "#e6b325", title: "New Review", body: "Sarah M. gave you 5 stars — great work!", time: "Yesterday" },
  { id: 6, icon: "BookOpen", tint: "#8b5cf6", title: "New Lesson Added", body: "Budgeting 101 is ready · +250 XP waiting", time: "Yesterday" },
];

export const transactions = [
  { id: 1, title: "Grocery Run", type: "in", amount: 20, date: "Jun 18", icon: "ShoppingCart" },
  { id: 2, title: "Dog Walking", type: "in", amount: 15, date: "Jun 17", icon: "Dog" },
  { id: 3, title: "Saved to Bicycle Goal", type: "save", amount: 30, date: "Jun 16", icon: "PiggyBank" },
  { id: 4, title: "Lawn Mowing", type: "in", amount: 25, date: "Jun 15", icon: "Sprout" },
  { id: 5, title: "Car Wash", type: "in", amount: 30, date: "Jun 12", icon: "CarFront" },
];

export const goals = [
  { name: "New Bicycle", target: 250, saved: 175, tint: "#f5911e" },
  { name: "Video Game", target: 60, saved: 42, tint: "#3b57c9" },
];

export const lessons = [
  { title: "Budgeting 101", desc: "Split earnings into save, spend & share", xp: 250, mins: 6, done: false, icon: "Wallet" },
  { title: "What is Interest?", desc: "How your savings can grow over time", xp: 200, mins: 5, done: true, icon: "TrendingUp" },
  { title: "Smart Spending", desc: "Needs vs. wants — make money last", xp: 200, mins: 4, done: true, icon: "ShoppingBag" },
  { title: "Your First Resume", desc: "Turn completed jobs into experience", xp: 300, mins: 8, done: false, icon: "FileText" },
];

export const onboarding = [
  {
    img: "/assets/onboard-globe.png",
    bg: "linear-gradient(180deg,#4a63d6 0%,#2f47a8 100%)",
    title: "Discover Chores Near You",
    text: "Browse real tasks posted by background-checked neighbors. Choose what fits your schedule and skills.",
  },
  {
    img: "/assets/onboard-team.png",
    bg: "linear-gradient(180deg,#57b24a 0%,#3d8f34 100%)",
    title: "Complete Tasks, Get Paid",
    text: "Finish the job, earn real money, and build your reputation with every completed chore.",
  },
  {
    img: "/assets/onboard-rocket.png",
    bg: "linear-gradient(180deg,#f5a63a 0%,#e97f0c 100%)",
    title: "Level Up Your Skills",
    text: "Gain XP, unlock achievements, and master real financial literacy along the way.",
  },
];


// ---------- Ranking ladder (reach a rank at N jobs OR $ earned) ----------
export const rankTiers = [
  {
    key: "associate", title: "ASSOCIATE", tier: "Bronze", color: "#c98a4b", icon: "Sprout",
    jobs: 0, dollars: 0,
    perks: ["Welcome starter badge", "Access to all neighborhood chores", "Financial literacy Academy"],
  },
  {
    key: "manager", title: "MANAGER", tier: "Silver", color: "#9aa3b2", icon: "Star",
    jobs: 10, dollars: 100,
    perks: ["Silver profile badge", "Early access to new chores nearby", "$5 Academy bonus reward"],
  },
  {
    key: "director", title: "DIRECTOR", tier: "Gold", color: "#e6b325", icon: "Award",
    jobs: 30, dollars: 300,
    perks: ["Gold “Trusted Do’er” badge", "Featured in neighbor search", "Monthly gift-card raffle entry"],
  },
  {
    key: "vp", title: "NEIGHBORHOOD VP", tier: "Platinum", color: "#7f8fb0", icon: "Trophy",
    jobs: 50, dollars: 500,
    perks: ["Platinum badge + custom profile theme", "Priority booking with top neighbors", "Exclusive skill workshops"],
  },
  {
    key: "ceo", title: "NEIGHBORHOOD CEO", tier: "Diamond", color: "#4fc3e8", icon: "Crown",
    jobs: 70, dollars: 1000,
    perks: ["Diamond CEO trophy", "Top-of-search all season", "Invite to GEN-DO Leaders events", "Downloadable resume of achievements"],
  },
];

export function computeRankIndex(jobsDone, earned) {
  let idx = 0;
  rankTiers.forEach((t, i) => {
    if (jobsDone >= t.jobs || earned >= t.dollars) idx = i;
  });
  return idx;
}

// ---------- Master suggested job list (what kids can do) — for Posters ----------
export const masterJobs = [
  { title: "Dog Walking", category: "Pets", icon: "Dog", tint: "#f5911e", pay: 15 },
  { title: "Baby Sitting", category: "Indoor", icon: "Baby", tint: "#e0533d", pay: 40 },
  { title: "Yard Work", category: "Outdoor", icon: "Trees", tint: "#4fae3f", pay: 30 },
  { title: "Pressure Washing", category: "Outdoor", icon: "Droplets", tint: "#22a7c9", pay: 35 },
  { title: "Set Up Yard Sales", category: "Errands", icon: "Tag", tint: "#8b5cf6", pay: 25 },
  { title: "Trash Cans to Street", category: "Errands", icon: "Trash2", tint: "#3b57c9", pay: 10 },
  { title: "Water Plants", category: "Outdoor", icon: "Flower2", tint: "#4fae3f", pay: 12 },
  { title: "Get the Mail", category: "Errands", icon: "Mailbox", tint: "#f5911e", pay: 8 },
  { title: "Tutor Younger Kids", category: "Indoor", icon: "BookOpen", tint: "#8b5cf6", pay: 30 },
  { title: "Teach Sports", category: "Outdoor", icon: "Trophy", tint: "#e6b325", pay: 25 },
  { title: "Run Errands", category: "Errands", icon: "ShoppingBag", tint: "#3b57c9", pay: 20 },
  { title: "Distribute Flyers", category: "Errands", icon: "Newspaper", tint: "#22a7c9", pay: 18 },
  { title: "Organize Pantry", category: "Indoor", icon: "Boxes", tint: "#f5911e", pay: 22 },
  { title: "Clean Out Garage", category: "Indoor", icon: "Warehouse", tint: "#7f8fb0", pay: 40 },
];

// The signed-in Neighbor (poster) for the demo
export const currentNeighbor = {
  name: "The Danforth Family",
  id: "neighbor-danforth",
  initial: "D",
  color: "#f5911e",
  rating: 5.0,
  bgStatus: "verified", // background check passed → allowed to post
  bgProvider: "Checkr",
  bgClearedOn: "May 2, 2025",
};

// ---------- Seeded neighbor-posted jobs (drive the cross-role sync demo) ----------
// status: open -> kid_accepted -> parent_approved (or declined)
export const seededPostedJobs = [
  {
    id: "pj-yard", title: "Yard Work", category: "Outdoor", icon: "Trees", tint: "#4fae3f",
    pay: 35, xp: 250, duration: "2 hr", distance: "0.2 mi", schedule: "Sat, Jun 21 · 9:00 AM",
    poster: "neighbor-danforth", status: "open",
    desc: "Rake the leaves, weed the front garden beds, and sweep the walkway. Tools provided.",
  },
  {
    id: "pj-trash", title: "Trash Cans to Street", category: "Errands", icon: "Trash2", tint: "#3b57c9",
    pay: 10, xp: 150, duration: "15 min", distance: "0.1 mi", schedule: "Mon, Jun 23 · 7:00 AM",
    poster: "neighbor-lopez", status: "kid_accepted",
    desc: "Bring both the trash & recycle bins to the curb on collection morning, then back after pickup.",
  },
  {
    id: "pj-mail", title: "Get Mail & Water Plants", category: "Errands", icon: "Mailbox", tint: "#f5911e",
    pay: 20, xp: 200, duration: "20 min", distance: "0.3 mi", schedule: "Jun 24–26 · 5:00 PM",
    poster: "neighbor-chen", status: "parent_approved",
    desc: "Collect the mail and water the porch plants each evening while we're travelling.",
  },
];
